"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "JobsEventService", {
    enumerable: true,
    get: function() {
        return JobsEventService;
    }
});
const _bull = require("@nestjs/bull");
const _bull1 = require("bull");
const _eventemitter = require("@nestjs/event-emitter");
const _common = require("@nestjs/common");
const _Jobs = require("~/interface/Jobs");
const _models = require("~/models");
const _globals = require("~/utils/globals");
const _pubsubredis = require("~/redis/pubsub-redis");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let JobsEventService = class JobsEventService {
    onActive(job) {
        if (_Jobs.SKIP_STORING_JOB_META.includes(job.data.jobName)) {
            this.eventEmitter.emit(_Jobs.JobEvents.STATUS, {
                id: job.id.toString(),
                status: _Jobs.JobStatus.ACTIVE
            });
            return;
        }
        _models.Job.update({
            workspace_id: _globals.RootScopes.ROOT,
            base_id: _globals.RootScopes.ROOT
        }, job.id.toString(), {
            status: _Jobs.JobStatus.ACTIVE
        }).then(()=>{
            this.eventEmitter.emit(_Jobs.JobEvents.STATUS, {
                id: job.id.toString(),
                status: _Jobs.JobStatus.ACTIVE
            });
        }).catch((error)=>{
            this.logger.error(`Failed to update job (${job.id}) status to active: ${error.message}`);
        });
    }
    onFailed(job, error) {
        _pubsubredis.PubSubRedis.publish(`worker:job:${job.id}`, {
            success: false,
            error
        }).catch((error)=>{
            this.logger.error(`Failed to publish job result to pubsub: ${error.message}`);
        });
        this.logger.error(`---- !! JOB FAILED !! ----\nid:${job.id}\nerror:${error.name} (${error.message})\n\nstack: ${error.stack}`);
        if (_Jobs.SKIP_STORING_JOB_META.includes(job.data.jobName)) {
            this.eventEmitter.emit(_Jobs.JobEvents.STATUS, {
                id: job.id.toString(),
                status: _Jobs.JobStatus.FAILED,
                data: {
                    error: {
                        message: error == null ? void 0 : error.message
                    },
                    result: error == null ? void 0 : error.data
                }
            });
            return;
        }
        _models.Job.update({
            workspace_id: _globals.RootScopes.ROOT,
            base_id: _globals.RootScopes.ROOT
        }, job.id.toString(), {
            status: _Jobs.JobStatus.FAILED,
            result: error == null ? void 0 : error.data
        }).then(()=>{
            const newLocal = this;
            newLocal.eventEmitter.emit(_Jobs.JobEvents.STATUS, {
                id: job.id.toString(),
                status: _Jobs.JobStatus.FAILED,
                data: {
                    error: {
                        message: error == null ? void 0 : error.message
                    },
                    result: error == null ? void 0 : error.data
                }
            });
        }).catch((error)=>{
            this.logger.error(`Failed to update job (${job.id}) status to failed: ${error.message}`);
        });
    }
    onCompleted(job, data) {
        _pubsubredis.PubSubRedis.publish(`worker:job:${job.id}`, {
            success: true,
            result: data
        }).catch((error)=>{
            this.logger.error(`Failed to publish job result to pubsub: ${error.message}`);
        });
        // If job was requeued, don't update the status
        if (data === _Jobs.JobStatus.REQUEUED) {
            this.eventEmitter.emit(_Jobs.JobEvents.STATUS, {
                id: job.id.toString(),
                status: _Jobs.JobStatus.REQUEUED
            });
            return;
        }
        // Don't store job results for certain job types
        if (_Jobs.SKIP_STORING_JOB_META.includes(job.data.jobName)) {
            this.eventEmitter.emit(_Jobs.JobEvents.STATUS, {
                id: job.id.toString(),
                status: _Jobs.JobStatus.COMPLETED,
                data: {
                    result: data
                }
            });
            return;
        }
        _models.Job.update({
            workspace_id: _globals.RootScopes.ROOT,
            base_id: _globals.RootScopes.ROOT
        }, job.id.toString(), {
            status: _Jobs.JobStatus.COMPLETED,
            result: data
        }).then(()=>{
            this.eventEmitter.emit(_Jobs.JobEvents.STATUS, {
                id: job.id.toString(),
                status: _Jobs.JobStatus.COMPLETED,
                data: {
                    result: data
                }
            });
        }).catch((error)=>{
            this.logger.error(`Failed to update job (${job.id}) status to completed: ${error.message}`);
        });
    }
    constructor(eventEmitter){
        this.eventEmitter = eventEmitter;
        this.logger = new _common.Logger(JobsEventService.name);
        this.awaitingResults = new Map();
    }
};
_ts_decorate([
    (0, _bull.OnQueueActive)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _bull1.Job === "undefined" ? Object : _bull1.Job
    ]),
    _ts_metadata("design:returntype", void 0)
], JobsEventService.prototype, "onActive", null);
_ts_decorate([
    (0, _bull.OnQueueFailed)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _bull1.Job === "undefined" ? Object : _bull1.Job,
        Object
    ]),
    _ts_metadata("design:returntype", void 0)
], JobsEventService.prototype, "onFailed", null);
_ts_decorate([
    (0, _bull.OnQueueCompleted)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _bull1.Job === "undefined" ? Object : _bull1.Job,
        Object
    ]),
    _ts_metadata("design:returntype", void 0)
], JobsEventService.prototype, "onCompleted", null);
JobsEventService = _ts_decorate([
    (0, _bull.Processor)(_Jobs.JOBS_QUEUE),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _eventemitter.EventEmitter2 === "undefined" ? Object : _eventemitter.EventEmitter2
    ])
], JobsEventService);
